import { FC } from 'react'

import { IconPlus, Button } from '@sequencehq/core-components'

import { ConfigFormTemplate } from 'Automations/nodeDefinitions/components'
import { useGroupEditing } from '../../hooks'
import { ConditionItem } from './Condition'

export const GroupEditor: FC<{
  nodeId: string
  onAddGroup?: () => void
}> = ({ nodeId, onAddGroup }) => {
  const { group, conditions, addCondition, canAddCondition } = useGroupEditing({
    nodeId
  })

  if (!group) return null

  return (
    <>
      {conditions.map((condition, index) => (
        <ConfigFormTemplate.Row
          key={condition.id}
          label={index === 0 ? 'If' : 'And'}
          gap="8px"
        >
          <ConditionItem nodeId={nodeId} conditionId={condition.id} />
        </ConfigFormTemplate.Row>
      ))}

      <ConfigFormTemplate.Footer>
        <Button
          data-testid="automations.editor.configForm.switch.addCondition"
          variant="secondary"
          leadingIcon={<IconPlus />}
          onClick={addCondition}
          disabled={!canAddCondition}
        >
          Add condition
        </Button>

        {onAddGroup && (
          <Button
            data-testid="automations.editor.configForm.switch.addBranch"
            variant="secondary"
            onClick={onAddGroup}
            leadingIcon={<IconPlus />}
          >
            Add branch
          </Button>
        )}
      </ConfigFormTemplate.Footer>
    </>
  )
}
